export interface WebViewDetectionResult {
  isWebView: boolean;
  name: string;
  reason: string;
}

export interface WebViewDetectionInput {
  userAgent: string;
  standalone?: boolean;
}

const knownWebViews: Array<[RegExp, string]> = [
  [/\bInstagram\b/i, "Instagram"],
  [/\bFBAN\b|\bFBAV\b|\bFB_IAB\b|\bFB4A\b|\bFBIOS\b/i, "Facebook"],
  [/\bMessenger\b|\bFBAN\/Messenger\b/i, "Messenger"],
  [/\bLinkedInApp\b/i, "LinkedIn"],
  [/\bLine\//i, "LINE"],
  [/\bTikTok\b|\bBytedanceWebview\b/i, "TikTok"],
  [/\bTwitter\b|\bX-Twitter\b/i, "X"],
  [/\bSnapchat\b/i, "Snapchat"],
  [/\bwv\b|; wv\)/i, "Android WebView"],
];

export function detectWebView(input: WebViewDetectionInput = { userAgent: navigator.userAgent }): WebViewDetectionResult {
  const userAgent = input.userAgent;

  for (const [pattern, name] of knownWebViews) {
    if (pattern.test(userAgent)) {
      return {
        isWebView: true,
        name,
        reason: "known-webview-user-agent",
      };
    }
  }

  if (isIosWebView(userAgent, input.standalone)) {
    return {
      isWebView: true,
      name: "iOS WebView",
      reason: "ios-applewebkit-without-safari",
    };
  }

  return {
    isWebView: false,
    name: "System browser",
    reason: "no-webview-signature",
  };
}

function isIosWebView(userAgent: string, standalone?: boolean): boolean {
  const isIos = /\b(iPhone|iPad|iPod)\b/i.test(userAgent);
  const isAppleWebKit = /\bAppleWebKit\b/i.test(userAgent);
  const hasSafariToken = /\bSafari\b/i.test(userAgent);
  const hasCriOsOrFxiOs = /\b(CriOS|FxiOS|EdgiOS)\b/i.test(userAgent);

  if (standalone === true) {
    return false;
  }

  return isIos && isAppleWebKit && !hasSafariToken && !hasCriOsOrFxiOs;
}
